(function () {
  'use strict';

  var STORAGE_KEY = 'ayami_color_vote_abuja';
  var PENDING_SAVE_KEY = 'color_vote_pending_save';
  var AUTO_SAVE_PARAM = 'color_vote_auto_save';
  var VOTE_SAVE_PATH = '/apps/ayami-color-guide/vote-save';

  function isHtmlResponse(text) {
    return /^\s*(<!doctype html|<html[\s>])/i.test(String(text || '').trim());
  }

  function resolveSaveUrl(raw) {
    var path = VOTE_SAVE_PATH;
    try {
      if (raw) {
        if (/^https?:\/\//i.test(raw)) {
          var absolute = new URL(raw);
          if (absolute.origin === window.location.origin) {
            path = absolute.pathname;
          }
        } else if (String(raw).charAt(0) === '/') {
          path = String(raw).split('?')[0];
        }
      }
    } catch (e) {
      path = VOTE_SAVE_PATH;
    }

    path = path.replace(/^\/(en|es|fr|de|ca|it|pl|sv)(?=\/apps\/)/i, '');
    if (path.indexOf('/apps/ayami-color-guide/vote-save') !== 0) {
      path = VOTE_SAVE_PATH;
    }

    return new URL(path, window.location.origin).toString();
  }

  function formatSaveError(error, saveUrl) {
    if (!error) {
      return 'We could not save your votes right now. Please try again.';
    }
    if (error.status === 401) {
      return '';
    }
    if (error.status === 404) {
      return 'Vote save URL not found (404). Expected ' + saveUrl + '.';
    }
    if (error.status === 405) {
      return 'Vote saving needs a worker update � redeploy color-guide-save-worker.';
    }
    if (error.detail) {
      if (/metafield definition/i.test(error.detail)) {
        return 'Shop setup incomplete: create customer metafield custom.color_votes (JSON) in Shopify Admin.';
      }
      if (/OAuth token request failed/i.test(error.detail) || /CLIENT_ID/i.test(error.detail)) {
        return 'Server auth failed � check Cloudflare secrets (SHOPIFY_CLIENT_ID / SHOPIFY_CLIENT_SECRET) and that the app is installed on the store.';
      }
      return 'Could not save: ' + error.detail;
    }
    if (error.html || (error.detail && isHtmlResponse(error.detail))) {
      return 'The vote server returned an error page (HTTP ' + (error.status || '?') + '). Please try again in a moment.';
    }
    if (error.status) {
      return 'Could not save (HTTP ' + error.status + '). Please try again.';
    }
    if (error.message && error.message !== 'Save failed') {
      return 'Could not save: ' + error.message;
    }
    return 'We could not save your votes right now. Please try again.';
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function parseMaxVotes(root) {
    var raw = root.getAttribute('data-max-votes');
    var n = parseInt(raw, 10);
    if (!Number.isFinite(n) || n <= 0) {
      return null;
    }
    return n;
  }

  function getConfig(root) {
    var customerId = root.getAttribute('data-customer-id') || '';
    return {
      loggedIn: root.getAttribute('data-customer-logged-in') === 'true',
      customerId: customerId,
      saveUrl: resolveSaveUrl(root.getAttribute('data-save-url')),
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      registerUrl: root.getAttribute('data-register-url') || '/account/register',
      votePage: root.getAttribute('data-vote-page') || window.location.pathname,
    };
  }

  function getSelectedCards(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll('.color-vote__card--votable input:checked')
    ).map(function (input) {
      return input.closest('.color-vote__card');
    });
  }

  function cardMeta(card) {
    return {
      vendorCode: card.getAttribute('data-vendor-code') || '',
      name: card.getAttribute('data-color-name') || '',
      hex: card.getAttribute('data-color-hex') || '#cccccc',
    };
  }

  function updateCounter(grid, counterEl, maxVotes) {
    var count = getSelectedCards(grid).length;
    if (maxVotes) {
      counterEl.textContent = count + ' of ' + maxVotes + ' selected';
      counterEl.classList.toggle('is-limit', count >= maxVotes);
    } else {
      counterEl.textContent = count + ' selected';
      counterEl.classList.remove('is-limit');
    }
  }

  function syncCardStates(grid, maxVotes) {
    var selected = getSelectedCards(grid);
    var atLimit = maxVotes !== null && selected.length >= maxVotes;
    var cards = grid.querySelectorAll('.color-vote__card--votable');
    Array.prototype.forEach.call(cards, function (card) {
      var input = card.querySelector('input[type="checkbox"]');
      var isSelected = input && input.checked;
      card.classList.toggle('color-vote__card--selected', !!isSelected);
      if (input) {
        input.disabled = atLimit && !isSelected;
      }
      card.setAttribute('aria-disabled', atLimit && !isSelected ? 'true' : 'false');
    });
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function readSavedVotesFromPage() {
    var scriptEl = document.getElementById('ColorVoteSavedData');
    if (!scriptEl || !scriptEl.textContent.trim()) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeVotePayload(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var details = Array.isArray(raw.vote_details) ? raw.vote_details.slice() : [];
    if (!details.length && Array.isArray(raw.votes)) {
      details = raw.votes.map(function (code) {
        return {
          vendor_code: String(code),
          name: String(code),
          hex: '#cccccc',
        };
      });
    }
    if (!details.length) return null;
    return {
      fabric: raw.fabric || 'abuja',
      fabric_label: raw.fabric_label || 'Bamboo jersey',
      votes: details.map(function (item) { return item.vendor_code; }),
      vote_details: details,
      submitted_at: raw.submitted_at || null,
      page: raw.page || '',
    };
  }

  function getSavedVotesConfig(root) {
    return {
      loggedIn: root.getAttribute('data-customer-logged-in') === 'true',
      votePageUrl: root.getAttribute('data-vote-page') || '/pages/color-vote',
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      registerUrl: root.getAttribute('data-register-url') || '/account/register',
    };
  }

  function loadSavedVotes() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function loadSavedVotesSource() {
    return normalizeVotePayload(readSavedVotesFromPage()) || normalizeVotePayload(loadSavedVotes());
  }

  function applySavedVotes(grid, saved) {
    if (!saved || !Array.isArray(saved.votes)) return;
    saved.votes.forEach(function (code) {
      var card = grid.querySelector('[data-vendor-code="' + code + '"]');
      if (!card) return;
      var input = card.querySelector('input[type="checkbox"]');
      if (input) input.checked = true;
    });
  }

  function showSavedBanner(root, saved, synced) {
    if (!saved || !saved.submitted_at) return;
    var banner = root.querySelector('[data-color-vote-saved-banner]');
    if (!banner) return;
    var date = new Date(saved.submitted_at);
    var dateLabel = Number.isNaN(date.getTime())
      ? ''
      : ' on ' + date.toLocaleDateString();
    var label = synced
      ? 'Your votes were saved to your account' + dateLabel + '. You can update your picks below.'
      : 'You submitted votes' + dateLabel + ' on this device. Log in and submit again to sync to your account.';
    banner.textContent = label;
    banner.classList.remove('hidden');
  }

  function buildPayload(root, grid) {
    var votes = getSelectedCards(grid).map(function (card) {
      var meta = cardMeta(card);
      return {
        vendor_code: meta.vendorCode,
        name: meta.name,
        hex: meta.hex,
      };
    });
    return {
      fabric: 'abuja',
      fabric_label: 'Bamboo jersey',
      votes: votes.map(function (v) { return v.vendor_code; }),
      vote_details: votes,
      submitted_at: new Date().toISOString(),
      page: root.getAttribute('data-vote-page') || window.location.pathname,
      customer_id: root.getAttribute('data-customer-id') || null,
    };
  }

  function buildResultHtml(payload, synced, options) {
    options = options || {};
    if (!payload.vote_details.length) {
      if (options.savedPage) {
        return (
          '<p>You did not select any colors. Come back any time to vote.</p>' +
          '<div class="color-vote__actions">' +
            '<a class="button" href="' + escapeHtml(options.votePageUrl || '/pages/color-vote') + '">Vote for colors</a>' +
          '</div>'
        );
      }
      return (
        '<h2 class="color-vote__result-title">Thanks for taking a look</h2>' +
        '<p>You did not select any colors. Come back any time to vote.</p>'
      );
    }

    var chips = payload.vote_details.map(function (vote) {
      return (
        '<li class="color-vote__result-chip">' +
          '<span class="color-vote__result-chip-swatch" style="background-color:' + escapeHtml(vote.hex || '#cccccc') + '" aria-hidden="true"></span>' +
          '<span>' + escapeHtml(vote.name || vote.vendor_code) + '</span>' +
        '</li>'
      );
    }).join('');

    var html = options.savedPage
      ? ''
      : '<h2 class="color-vote__result-title">Thank you!</h2>';

    if (options.savedBanner) {
      html += '<p class="color-vote__saved-banner" role="status">' + escapeHtml(options.savedBanner) + '</p>';
    }

    if (!options.savedPage) {
      html +=
        '<p>We received your votes for ' + payload.vote_details.length + ' color' +
          (payload.vote_details.length === 1 ? '' : 's') + '.</p>';
      if (synced) {
        html += '<p>Your picks are saved to your customer profile and counted in our shop tally.</p>';
      }
    } else if (payload.submitted_at) {
      var date = new Date(payload.submitted_at);
      if (!Number.isNaN(date.getTime())) {
        html += '<p class="color-vote__submitted-at">Last updated ' + escapeHtml(date.toLocaleDateString()) + '</p>';
      }
    }

    html += '<ul class="color-vote__result-list">' + chips + '</ul>';

    if (options.savedPage && options.votePageUrl) {
      html +=
        '<div class="color-vote__actions">' +
          '<a class="button" href="' + escapeHtml(options.votePageUrl) + '">Update vote</a>' +
        '</div>';
    }

    return html;
  }

  function renderResult(resultEl, payload, synced, options) {
    resultEl.innerHTML = buildResultHtml(payload, synced, options || {});
  }

  function renderLoginPromptVotes(config) {
    return (
      '<div class="color-vote__empty-state">' +
        '<p>Log in or create an account to view your saved color votes.</p>' +
        '<div class="color-vote__actions">' +
          '<a class="button" href="' + escapeHtml(config.loginUrl) + '">Log in</a>' +
          '<a class="button button--secondary" href="' + escapeHtml(config.registerUrl) + '">Create account</a>' +
        '</div>' +
      '</div>'
    );
  }

  function renderEmptyVotes(config) {
    return (
      '<div class="color-vote__empty-state">' +
        '<p>You have not voted for any colors yet.</p>' +
        '<div class="color-vote__actions">' +
          '<a class="button" href="' + escapeHtml(config.votePageUrl) + '">Vote on colors</a>' +
        '</div>' +
      '</div>'
    );
  }

  function initSavedVotesPage() {
    var root = document.querySelector('[data-color-vote-saved]');
    if (!root) return;

    var target = root.querySelector('[data-color-vote-saved-content]');
    if (!target) return;

    var config = getSavedVotesConfig(root);
    if (!config.loggedIn) {
      target.innerHTML = renderLoginPromptVotes(config);
      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
      return;
    }

    var payload = loadSavedVotesSource();
    if (!payload) {
      target.innerHTML = renderEmptyVotes(config);
      if (typeof window.kailaRefreshPreferencesHub === 'function') {
        window.kailaRefreshPreferencesHub();
      }
      return;
    }

    saveLocally(payload);

    var params = new URLSearchParams(window.location.search);
    var savedBanner = params.get('votes_saved') === '1' ? 'Your votes have been saved.' : '';

    target.innerHTML = buildResultHtml(payload, true, {
      savedPage: true,
      savedBanner: savedBanner,
      votePageUrl: config.votePageUrl,
    });

    if (params.get('votes_saved') === '1') {
      try {
        var cleanUrl = window.location.pathname + window.location.search
          .replace(/([?&])votes_saved=1&?/, '$1')
          .replace(/[?&]$/, '');
        window.history.replaceState({}, '', cleanUrl || window.location.pathname);
      } catch (e) {
        /* ignore */
      }
    }

    if (typeof window.kailaRefreshPreferencesHub === 'function') {
      window.kailaRefreshPreferencesHub();
    }
  }

  function saveLocally(payload) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore quota errors */
    }
  }

  function readPendingSave() {
    try {
      var raw = sessionStorage.getItem(PENDING_SAVE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearPendingSave() {
    try {
      sessionStorage.removeItem(PENDING_SAVE_KEY);
    } catch (e) {
      /* ignore */
    }
  }

  function storePendingVote(payload) {
    saveLocally(payload);
    try {
      sessionStorage.setItem(PENDING_SAVE_KEY, JSON.stringify(payload));
    } catch (e) {
      /* ignore */
    }
  }

  function redirectToLoginForSave(config) {
    var returnPath = config.votePage || window.location.pathname;
    var separator = returnPath.indexOf('?') >= 0 ? '&' : '?';
    var returnUrl = returnPath + separator + AUTO_SAVE_PARAM + '=1';
    window.location.href = config.loginUrl + '?return_url=' + encodeURIComponent(returnUrl);
  }

  function requireLoginForSubmit(root, hintEl, payload, config) {
    storePendingVote(payload);
    if (hintEl) {
      hintEl.textContent = 'Redirecting you to log in so we can save your votes�';
      hintEl.classList.remove('is-error');
    }
    redirectToLoginForSave(config);
  }

  function postVotes(saveUrl, payload, attempt) {
    var url = saveUrl || resolveSaveUrl('', payload.customer_id);
    attempt = attempt || 0;
    return fetch(url, {
      method: 'POST',
      redirect: 'manual',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ votes: payload }),
    }).then(function (res) {
      if (res.type === 'opaqueredirect' || res.status === 301 || res.status === 302 || res.status === 303 || res.status === 307 || res.status === 308) {
        var redirectError = new Error('Save was redirected (session may have expired)');
        redirectError.status = res.status || 401;
        throw redirectError;
      }
      return res.text().then(function (text) {
        if (isHtmlResponse(text)) {
          var htmlError = new Error('Save endpoint returned HTML instead of JSON');
          htmlError.status = res.status;
          htmlError.html = true;
          throw htmlError;
        }
        var body = {};
        if (text) {
          try {
            body = JSON.parse(text);
          } catch (e) {
            var parseError = new Error('Save endpoint returned invalid JSON');
            parseError.status = res.status;
            throw parseError;
          }
        }
        if (!res.ok) {
          var error = new Error(body.error || body.detail || 'Save failed');
          error.status = res.status;
          error.detail = body.detail || body.tally_error || body.error || null;
          throw error;
        }
        if (!body || body.ok === false) {
          var failError = new Error(body.error || body.detail || 'Save failed');
          failError.status = res.status;
          failError.detail = body.detail || body.error || null;
          throw failError;
        }
        if (body.ok !== true) {
          var badPayload = new Error((body && (body.error || body.detail)) || 'Save failed');
          badPayload.status = res.status;
          badPayload.detail = body && (body.detail || body.error);
          throw badPayload;
        }
        return body;
      });
    }).catch(function (error) {
      if (attempt < 1 && error && (error.html || error.status === 401)) {
        return new Promise(function (resolve) {
          setTimeout(resolve, 600);
        }).then(function () {
          return postVotes(url, payload, attempt + 1);
        });
      }
      throw error;
    });
  }

  function submitVotes(root, form, grid, counterEl, hintEl, resultEl, maxVotes, config) {
    var payload = buildPayload(root, grid);

    if (!payload.vote_details.length) {
      if (hintEl) {
        hintEl.textContent = 'Please select at least one color before submitting.';
        hintEl.classList.add('is-error');
      }
      return;
    }

    if (!config.loggedIn) {
      requireLoginForSubmit(root, hintEl, payload, config);
      return;
    }

    saveLocally(payload);

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.setAttribute('aria-busy', 'true');
    }
    if (hintEl) {
      hintEl.textContent = 'Saving�';
      hintEl.classList.remove('is-error');
    }

    postVotes(config.saveUrl, payload)
      .then(function (result) {
        clearPendingSave();
        if (hintEl) hintEl.textContent = '';
        var synced = !!(result && result.customer_saved !== false);
        showSavedBanner(root, payload, synced);
        if (resultEl) {
          renderResult(resultEl, payload, synced);
          resultEl.classList.remove('hidden');
          resultEl.focus();
          resultEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (error) {
        if (error && error.status === 401) {
          if (config.loggedIn && config.customerId) {
            if (hintEl) {
              hintEl.textContent = 'Your login session could not be verified. Please log out, log back in, and submit again.';
              hintEl.classList.add('is-error');
            }
            return;
          }
          requireLoginForSubmit(root, hintEl, payload, config);
          return;
        }
        if (hintEl) {
          var message = formatSaveError(error, config.saveUrl);
          if (message) {
            hintEl.textContent = message;
            hintEl.classList.add('is-error');
          }
        }
        var banner = root.querySelector('[data-color-vote-saved-banner]');
        if (banner) banner.classList.add('hidden');
        if (resultEl) resultEl.classList.add('hidden');
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
        }
      });
  }

  function processAutoSave(root, form, grid, counterEl, hintEl, resultEl, maxVotes, config) {
    var params = new URLSearchParams(window.location.search);
    if (params.get(AUTO_SAVE_PARAM) !== '1') return;
    if (!config.loggedIn) return;

    var pending = readPendingSave();
    if (pending && Array.isArray(pending.votes)) {
      applySavedVotes(grid, pending);
      syncCardStates(grid, maxVotes);
      updateCounter(grid, counterEl, maxVotes);
    }

    submitVotes(root, form, grid, counterEl, hintEl, resultEl, maxVotes, config);

    try {
      var cleanUrl = window.location.pathname + window.location.search
        .replace(/([?&])color_vote_auto_save=1&?/, '$1')
        .replace(/[?&]$/, '');
      window.history.replaceState({}, '', cleanUrl || window.location.pathname);
    } catch (e) {
      /* ignore */
    }
  }

  ready(function () {
    initSavedVotesPage();

    var root = document.querySelector('[data-color-vote-root]');
    if (!root) return;

    var form = root.querySelector('#ColorVoteForm');
    var grid = root.querySelector('[data-color-vote-grid]');
    var counterEl = root.querySelector('[data-color-vote-counter]');
    var hintEl = root.querySelector('[data-color-vote-hint]');
    var resultEl = root.querySelector('[data-color-vote-result]');
    var maxVotes = parseMaxVotes(root);
    var config = getConfig(root);

    if (!form || !grid || !counterEl) return;

    var saved = loadSavedVotesSource();
    if (saved) {
      applySavedVotes(grid, saved);
      showSavedBanner(root, saved, config.loggedIn && !!config.saveUrl);
    }

    function refreshUi() {
      syncCardStates(grid, maxVotes);
      updateCounter(grid, counterEl, maxVotes);
      if (hintEl && !hintEl.classList.contains('is-error')) {
        hintEl.textContent = '';
      }
    }

    refreshUi();

    grid.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'checkbox') return;
      refreshUi();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submitVotes(root, form, grid, counterEl, hintEl, resultEl, maxVotes, config);
    });

    processAutoSave(root, form, grid, counterEl, hintEl, resultEl, maxVotes, config);
  });
})();